import { Fragment } from "react";
import { Link as RouterLink } from "@tanstack/react-router";
import { Helmet } from "react-helmet-async";
import { Box, Button, Container, Link, Typography } from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";

const ServerError = ({ reset }) => {
  // Hooks

  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down("sm"));

  // Handle Retry & Refresh Browser Page & Go Home

  const handleRetry = () => {
    reset();
  };

  const handleRefreshBrowserPage = () => {
    window.location.reload();
  };

  // Rendering

  return (
    <Fragment>
      <Helmet>
        <title>Lean ads | Server Error</title>
      </Helmet>
      <Box
        sx={{
          alignItems: "center",
          backgroundColor: "background.default",
          display: "flex",
          minHeight: "100%",
          px: 3,
          py: "80px",
        }}
      >
        <Container>
          <Typography
            align="center"
            color="textPrimary"
            variant={mobileDevice ? "h4" : "h1"}
          >
            500: Server Error
          </Typography>
          <Typography
            align="center"
            color="textSecondary"
            sx={{ mt: 0.5 }}
            variant="subtitle2"
          >
            Hmm... the server decided to crash 💥 Apologies.
          </Typography>
          <Typography
            align="center"
            color="textSecondary"
            sx={{ mt: 2 }}
            variant="subtitle2"
          >
            You can cross your fingers 🤞 and{" "}
            <Link
              color="textPrimary"
              href="#"
              underline="hover"
              onClick={handleRetry}
            >
              try again
            </Link>
            .
          </Typography>
          <Typography
            align="center"
            color="textSecondary"
            sx={{ mt: 0.5 }}
            variant="subtitle2"
          >
            If it does not work, you can{" "}
            <Link
              color="textPrimary"
              href="#"
              underline="hover"
              onClick={handleRefreshBrowserPage}
            >
              refresh the page
            </Link>
            .
          </Typography>
          <Typography
            align="center"
            color="textSecondary"
            sx={{ mt: 0.5 }}
            variant="subtitle2"
          >
            {/*//TODO insert link "contact us"*/}
            If it still does not work, please feel free to contact us.
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: 6,
            }}
          >
            <Box
              alt="Server Error"
              component="img"
              src={`/static/error/error500_${theme.palette.mode}.svg`}
              sx={{
                height: "auto",
                maxWidth: "100%",
                width: 400,
              }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: 6,
            }}
          >
            <Button
              color="primary"
              component={RouterLink}
              to="/app/"
              variant="outlined"
            >
              Back Home
            </Button>
          </Box>
        </Container>
      </Box>
    </Fragment>
  );
};

export default ServerError;
